import { Paper, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface EventDetailsSectionCardProps {
    title: string;
    children: ReactNode;
}

export const EventDetailsSectionCard = ({ title, children }: EventDetailsSectionCardProps) => {
    return (
        <Paper
            elevation={2}
            sx={{
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
                display: 'block',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                mb: 2,
                borderRadius: 2,
                backgroundColor: 'background.paper',
                boxShadow: '0px 1px 4px 1px rgba(0,0,0,0.12)',
                // Keep overflow visible so the box shadow is not clipped by the card itself
                overflow: 'visible',
            }}
        >
            <Stack
                direction="column"
                spacing={1.5}
                sx={{
                    p: 2,
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    borderRadius: 2,
                    overflow: 'hidden',
                }}
            >
                <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, color: 'text.primary' }}
                >
                    {title}
                </Typography>
                <Stack
                    direction="column"
                    spacing={1.25}
                    sx={{
                        width: '100%',
                        maxWidth: '100%',
                        minWidth: 0,
                        boxSizing: 'border-box',
                        pl: 2,
                        pr: 1,
                    }}
                >
                    {children}
                </Stack>
            </Stack>
        </Paper>
    );
};
